(function () {
  const escapeHtml = (value) =>
    String(value || "").replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    }[char]));

  const normalizeKey = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/\+/g, " plus ")
      .replace(/&/g, " en ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const normalizeImageUrl = (value) => {
    const url = String(value || "").trim();
    if (!url) return "";
    if (url.startsWith("//")) return `${window.location.protocol}${url}`;
    return url;
  };

  const labels = {
    internet: "Internetradio",
    spotify: "Spotify Connect",
    bluetooth: "Bluetooth",
    battery: "Accu/batterij",
    cd: "CD-speler",
    tv: "TV-aansluiting",
    waterproof: "Waterbestendig",
    disposableBattery: "Losse AA/AAA-batterijen",
    aux: "AUX-ingang",
    app: "App-bediening",
    podcast: "Podcast",
    remote: "Afstandsbediening",
    headphone: "Hoofdtelefoon",
    emergency: "Noodfunctie"
  };

  const soundRank = {
    compact: 1,
    full: 2,
    premium: 3
  };

  const scoreProduct = (product, filters) => {
    let score = 0;
    const reasons = [];
    const audioScore = Number(product.audioScore || 0);

    if (filters.use && product.uses.includes(filters.use)) {
      score += 4;
      reasons.push("past bij gebruik");
    }

    filters.features.forEach((feature) => {
      if (product.features.includes(feature)) {
        score += 4;
        reasons.push(labels[feature]);
      } else if (feature === "tv" && product.features.includes("aux")) {
        score += 1;
      }
    });

    if (filters.sound) {
      const wanted = soundRank[filters.sound] || 0;
      const actual = soundRank[product.sound] || 0;
      if (actual === wanted) {
        score += 8;
        reasons.push("juiste geluidsklasse");
      } else if (actual > wanted) {
        score += 5;
        reasons.push("krachtiger geluid");
      } else if (actual < wanted) {
        score -= (wanted - actual) * 6;
      }

      if (filters.sound === "full" || filters.sound === "premium") {
        score += audioScore;
      }
    }

    if (filters.use === "hifi") {
      score += Math.floor(audioScore / 2);
    }

    if (filters.use === "portable" && filters.sound === "premium") {
      if (product.id === "north") {
        score += 10;
      } else if (product.features.includes("battery")) {
        score += 3;
      } else if (product.sound === "premium") {
        score -= 6;
      }
    }

    if (!filters.use && !filters.features.length && !filters.sound) {
      score += product.id === "201w" || product.id === "301" || product.id === "compact" ? 3 : 1;
    }

    if (product.status === "Binnenkort") {
      score -= 1;
    }

    return {
      product,
      score,
      reasons: [...new Set(reasons)].slice(0, 3)
    };
  };

  const getProductWarning = (product, filters) => {
    if (filters.use === "emergency" && filters.sound && filters.sound !== "compact") {
      return "Voor noodsituaties zijn alleen modellen met compact geluid geschikt. Dit model werkt met losse batterijen, maar is geen vol of hifi-systeem.";
    }

    if (filters.use === "portable" && filters.sound === "premium") {
      if (product.id === "north") {
        return "Beste draagbare keuze binnen Pinell, maar dit is geen krachtig hifi-systeem zoals de SUPERSOUND 701 of 901.";
      }

      if (!product.features.includes("battery")) {
        return "Voldoet beter aan de hifi-wens, maar is door formaat, gewicht en netvoeding niet geschikt om makkelijk mee te nemen.";
      }
    }

    if (
      filters.use === "portable" &&
      !product.features.includes("battery") &&
      (product.sound === filters.sound || soundRank[product.sound] > soundRank[filters.sound])
    ) {
      return "Voldoet aan je geluidswens, maar is minder geschikt voor onderweg omdat dit model netvoeding gebruikt.";
    }

    return "";
  };

  const getAdviceNotice = (filters) => {
    if (filters.use === "portable" && filters.sound === "premium") {
      return {
        title: "Eerlijk advies",
        text: "Onderweg gebruiken en krachtig hifi-geluid gaan niet echt samen in één model. Kies Pinell North als draagbaarheid het belangrijkst is. Kies SUPERSOUND 701 of 901 als hifi-geluid belangrijker is dan meenemen."
      };
    }

    if (filters.use === "emergency" && filters.sound && filters.sound !== "compact") {
      return {
        title: "Eerlijk advies",
        text: "Noodsituaties vragen om modellen die op losse AA/AAA-batterijen werken. Binnen dit assortiment zijn dat Pinell ResQ en SUPERSOUND 102W. Die keuze is alleen te combineren met compact geluid, niet met vol of krachtig hifi-geluid."
      };
    }

    return null;
  };

  const getCandidateProducts = (products, filters) => {
    let candidates = products;

    if (filters.use === "emergency") {
      candidates = candidates.filter((product) => product.features.includes("disposableBattery"));
    }

    if (filters.features.length) {
      candidates = candidates.filter((product) =>
        filters.features.every((feature) => product.features.includes(feature))
      );
    }

    return candidates;
  };

  const getNoMatchNotice = (filters) => {
    const selectedFeatures = filters.features.map((feature) => labels[feature] || feature);
    const pieces = [];

    if (filters.use === "emergency") {
      pieces.push("gebruik voor noodsituaties met losse AA/AAA-batterijen");
    }

    if (selectedFeatures.length) {
      pieces.push(selectedFeatures.join(", "));
    }

    if (filters.sound) {
      pieces.push(filters.sound === "compact" ? "compact geluid" : filters.sound === "full" ? "vol geluid" : "krachtig hifi-geluid");
    }

    return {
      title: "Geen exacte match",
      text: `Er is geen Pinell-model dat deze combinatie biedt${pieces.length ? `: ${pieces.join(" + ")}` : "."}. Pas een filter aan om geschikte modellen te zien.`
    };
  };

  const getFilters = (root) => {
    const use = root.querySelector("[data-pinell-filter='use']").value;
    const sound = root.querySelector("[data-pinell-filter='sound']").value;
    const features = Array.from(root.querySelectorAll("[data-pinell-feature]:checked")).map((node) => node.value);
    return { use, sound, features };
  };

  const applyProductMedia = (root, products) => {
    const mediaItems = [];

    root.querySelectorAll("[data-pinell-product-media-item]").forEach((node) => {
      mediaItems.push({
        id: node.dataset.id || "",
        handle: normalizeKey(node.dataset.handle),
        title: normalizeKey(node.dataset.title),
        url: node.dataset.url || "",
        image: normalizeImageUrl(node.dataset.image)
      });
    });

    return products.map((product) => {
      const candidates = [
        product.id,
        product.handle,
        ...(Array.isArray(product.mediaHandles) ? product.mediaHandles : [])
      ].map(normalizeKey).filter(Boolean);

      const exactMedia = mediaItems.find((item) =>
        item.id === product.id ||
        candidates.includes(item.handle)
      );
      const titleMedia = exactMedia || mediaItems.find((item) => {
        const productName = normalizeKey(product.name);
        return productName && item.title === productName;
      });
      const media = titleMedia;

      if (!media) return product;

      return {
        ...product,
        url: media.url || product.url,
        image: media.image || product.image
      };
    });
  };

  const formatList = (items) => items.map(escapeHtml).join(", ");

  const renderCard = ({ product, score, reasons }, index, filters) => {
    const badges = [
      `<span class="pinell-product-advisor__badge pinell-product-advisor__badge--match">Match ${index + 1}</span>`,
      `<span class="pinell-product-advisor__badge">${escapeHtml(product.status)}</span>`,
      ...reasons.map((reason) => `<span class="pinell-product-advisor__badge">${escapeHtml(reason)}</span>`)
    ].join("");

    const link = product.url
      ? `<a href="${escapeHtml(product.url)}">Bekijk product</a>`
      : "";
    const warning = getProductWarning(product, filters);
    const warningHtml = warning
      ? `<p class="pinell-product-advisor__warning">${escapeHtml(warning)}</p>`
      : "";
    const imageHtml = product.image
      ? `
        <div class="pinell-product-advisor__image">
          <img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.name)}" loading="lazy" onerror="this.closest('.pinell-product-advisor__image').remove();">
        </div>
      `
      : "";

    return `
      <article class="pinell-product-advisor__card">
        ${imageHtml}
        <div class="pinell-product-advisor__card-head">
          <div class="pinell-product-advisor__badge-row">${badges}</div>
          <h4>${escapeHtml(product.name)}</h4>
          <p>${escapeHtml(product.short)}</p>
        </div>
        <div class="pinell-product-advisor__meta">
          <span><strong>Ideaal voor:</strong> ${escapeHtml(product.bestFor)}</span>
          <span><strong>Speelt:</strong> ${formatList(product.plays)}</span>
          <span><strong>Geluid:</strong> ${escapeHtml(product.power)}</span>
        </div>
        ${warningHtml}
        ${link}
      </article>
    `;
  };

  const renderResults = (root, products) => {
    const filters = getFilters(root);
    const candidates = getCandidateProducts(products, filters);
    const resultLimit = filters.use === "emergency" ? 2 : 3;
    const ranked = candidates
      .map((product) => scoreProduct(product, filters))
      .sort((a, b) => b.score - a.score)
      .slice(0, resultLimit);
    const notice = getAdviceNotice(filters);
    const activeFilters = [
      filters.use,
      filters.sound,
      ...filters.features
    ].filter(Boolean).length;
    const noMatch = activeFilters && ranked.length === 0 ? getNoMatchNotice(filters) : null;
    const noticeHtml = noMatch
      ? `
        <div class="pinell-product-advisor__notice">
          <strong>${escapeHtml(noMatch.title)}</strong>
          <p>${escapeHtml(noMatch.text)}</p>
        </div>
      `
      : notice
      ? `
        <div class="pinell-product-advisor__notice">
          <strong>${escapeHtml(notice.title)}</strong>
          <p>${escapeHtml(notice.text)}</p>
        </div>
      `
      : "";

    root.querySelector("[data-pinell-results]").innerHTML = noticeHtml + ranked
      .map((item, index) => renderCard(item, index, filters))
      .join("");

    root.querySelector("[data-pinell-summary]").textContent = noMatch
      ? "Geen exacte match voor deze combinatie"
      : activeFilters
      ? `${ranked.length} adviesmatches op basis van je keuzes`
      : "Startadvies zonder voorkeuren";
  };

  const tableRows = [
    ["Type", "type"],
    ["Beste voor", "bestFor"],
    ["Speelt", "plays"],
    ["Functies", "features"],
    ["Geluid", "power"],
    ["Accu/batterij", "battery"],
    ["Display", "display"],
    ["Aansluitingen", "connections"],
    ["Afmetingen", "dimensions"],
    ["Gewicht", "weight"],
    ["Kleuren", "colors"],
    ["Opmerking", "notes"]
  ];

  const renderCompareTable = (root, products) => {
    const selectedIds = Array.from(root.querySelectorAll("[data-pinell-compare]:checked")).map((node) => node.value);
    const selected = products.filter((product) => selectedIds.includes(product.id));
    const table = root.querySelector("[data-pinell-compare-table]");

    if (!selected.length) {
      table.innerHTML = "<tbody><tr><td>Kies een model om te vergelijken.</td></tr></tbody>";
      return;
    }

    const header = `<thead><tr><th>Kenmerk</th>${selected.map((product) => {
      const image = product.image
        ? `<img class="pinell-product-advisor__table-image" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.name)}" loading="lazy" onerror="this.remove();">`
        : "";
      return `<th>${image}<span>${escapeHtml(product.name)}</span></th>`;
    }).join("")}</tr></thead>`;
    const body = tableRows.map(([label, key]) => {
      const cells = selected.map((product) => {
        const value = Array.isArray(product[key])
          ? product[key].map((item) => labels[item] || item).join(", ")
          : product[key];
        return `<td>${escapeHtml(value)}</td>`;
      }).join("");
      return `<tr><td>${escapeHtml(label)}</td>${cells}</tr>`;
    }).join("");

    table.innerHTML = `${header}<tbody>${body}</tbody>`;
  };

  const initAdvisor = (root) => {
    if (root.dataset.pinellProductAdvisorReady === "true") return;
    root.dataset.pinellProductAdvisorReady = "true";

    const dataNode = root.querySelector("[data-pinell-product-data]");
    const products = applyProductMedia(root, JSON.parse(dataNode.textContent || "[]"));
    const comparePickers = root.querySelector("[data-pinell-compare-pickers]");
    const defaultCompareIds = ["201w", "301", "501"];

    comparePickers.innerHTML = products.map((product, index) => `
      <label>
        <input type="checkbox" value="${escapeHtml(product.id)}" data-pinell-compare ${defaultCompareIds.includes(product.id) ? "checked" : ""}>
        ${escapeHtml(product.name)}
      </label>
    `).join("");

    root.querySelectorAll("[data-pinell-filter], [data-pinell-feature]").forEach((node) => {
      node.addEventListener("change", () => renderResults(root, products));
    });

    root.querySelector("[data-pinell-reset]").addEventListener("click", () => {
      root.querySelector("[data-pinell-filter='use']").value = "";
      root.querySelector("[data-pinell-filter='sound']").value = "";
      root.querySelectorAll("[data-pinell-feature]").forEach((node) => {
        node.checked = false;
      });
      renderResults(root, products);
    });

    root.querySelectorAll("[data-pinell-compare]").forEach((node) => {
      node.addEventListener("change", () => {
        const checked = Array.from(root.querySelectorAll("[data-pinell-compare]:checked"));
        if (checked.length > 3) {
          node.checked = false;
        }
        renderCompareTable(root, products);
      });
    });

    renderResults(root, products);
    renderCompareTable(root, products);
  };

  document.querySelectorAll("[data-pinell-product-advisor]").forEach(initAdvisor);
})();
